import { useState, useCallback } from 'react';

const useSnackbar = () => {
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

  const showSnack = useCallback((message, severity = 'success') => {
    setSnackbar({ open: true, message, severity });
  }, []);

  const closeSnack = useCallback(() => {
    setSnackbar((s) => ({ ...s, open: false }));
  }, []);

  return { snackbar, showSnack, closeSnack };
};

export default useSnackbar;
